/* eslint react/jsx-filename-extension: "off" */

import React from "react";
import moment from "moment";
import _ from "underscore";
import styled from "styled-components";
import vars from "@exovera/narrative-tracker-variables";
import { formatPosition } from "@exovera/helpers";

import { Trash, Pencil } from "@exovera/icons";

import { IconBox, ConfidenceBox, ConfidenceBlock, CenterIt, RightAlign } from "lib/table/tableTransforms.js";

// Table returns cell and row in params
const Header = styled.span`
	display: block;
	text-decoration: underline dotted;
	text-align: ${(props) => (props.rightAlign ? "right" : "center")};
`;

export const changeHeaderTransform = (params) => {
	const { cell, context, row } = params;
	const text = `Percentage baseline time series changes in the ${cell.toLowerCase()} term when predicted against this time series`;
	if (cell) {
		return (
			<Header
				onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
				onMouseLeave={() => context.closePredictiveHeaderTooltip()}
				rightAlign
			>
				{cell}
			</Header>
		);
	} else {
		return " ";
	}
};
export const confidenceHeaderTransform = (params) => {
	const { cell, context, row } = params;
	const text = "How accurate is this prediction";
	return (
		<Header
			onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
			onMouseLeave={() => context.closePredictiveHeaderTooltip()}
		>
			<ConfidenceBox>
				{_.times(5, (number) => {
					return <ConfidenceBlock active={number < 3} bgColor={context.darkUI ? vars.sky_2 : vars.text_1_5} />;
				})}
			</ConfidenceBox>
		</Header>
	);
};

const Text = styled.span`
	color: ${(props) => props.theColor};
	${vars.numberfont};
`;
export const changeTransform = (params) => {
	const { col, row } = params;
	const cell = row[col.id];

	const change = cell && cell.predictiveChange;
	const color = change >= 0 ? vars.grass_1 : vars.tangelo_2;
	if (change) {
		const roundedChange = Math.round(change * 100) / 100;
		return (
			<RightAlign>
				<Text theColor={color}>{`${roundedChange}%`}</Text>
			</RightAlign>
		);
	} else {
		return <RightAlign>--</RightAlign>;
	}
};
export const confidenceTransform = (params) => {
	const { col, context, row } = params;
	const cell = row[col.id];

	if (cell && cell.predictiveImpact) {
		const text = `Confidence score of ${Math.round(cell.predictiveImpact * 100) / 100}`;
		const impact =
			cell.predictiveImpact > 40
				? 5
				: cell.predictiveImpact > 30
				? 4
				: cell.predictiveImpact > 20
				? 3
				: cell.predictiveImpact > 10
				? 2
				: cell.predictiveImpact > 0
				? 1
				: 0;
		return (
			<CenterIt
				onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
				onMouseLeave={() => context.closePredictiveHeaderTooltip()}
			>
				<ConfidenceBox>
					{_.times(5, (number) => {
						return <ConfidenceBlock active={impact > number} bgColor={context.darkUI ? vars.sky_2 : vars.text_1_5} />;
					})}
				</ConfidenceBox>
			</CenterIt>
		);
	} else {
		return <CenterIt>--</CenterIt>;
	}
};

export const trashcanHeaderTransform = (params) => {
	const { row, context } = params;
	return (
		<IconBox
			onMouseEnter={(event) =>
				context.openContentHeaderTooltip({
					position: formatPosition(event.target),
					text: "Delete Search",
				})
			}
			onMouseLeave={() => context.closeContentHeaderTooltip()}
			boxSize={14}
			opacity={0.7}
		>
			<Trash fill={vars.sky_2}/>
		</IconBox>
	);
};
export const trashcanTransformMedia = (params) => {
	const { row, context } = params;
	if (row.userId && row.userId === context.userId) {
		return (
			<IconBox
				onMouseEnter={(event) =>
					context.openContentHeaderTooltip({
						position: formatPosition(event.target),
						text: "Delete Search",
					})
				}
				onMouseLeave={() => context.closeContentHeaderTooltip()}
				boxSize={14}
			>
				<Trash fill={vars.sky_2} scale={1} />
			</IconBox>
			)
	} else {
		return "";
	}
};
export const editHeaderTransform = (params) => {
	const { row, context } = params;
	return (
		<IconBox
			onMouseEnter={(event) =>
				context.openContentHeaderTooltip({
					position: formatPosition(event.target),
					text: "Edit Search",
				})
			}
			onMouseLeave={() => context.closeContentHeaderTooltip()}
			boxSize={14}
			opacity={0.7}
			margin="0 10px"
		>
			<Pencil fill={vars.sky_2} />
		</IconBox>
	);
};
export const editTransform = (params) => {
	const { row, context } = params;
	if (row.userId && row.userId === context.userId) {
		return (
			<IconBox
				onMouseEnter={(event) =>
					context.openContentHeaderTooltip({
						position: formatPosition(event.target),
						text: "Edit Search",
					})
				}
				onMouseLeave={() => context.closeContentHeaderTooltip()}
				boxSize={14}
			>
				<Pencil fill={vars.sky_2} />
			</IconBox>
		);
	} else {
		return "";
	}
};
export const createdByUser = (params) => {
	const { row, context } = params;
	return row && row.userId && row.userId === context.userId; // only user created rows have a userId
};
